import * as GENERAL_ACTION from 'js/constant/action/general'
import { handleActions } from 'redux-actions'

var isEnabled = false;
isEnabled = window.localStorage.getItem("verify-dark-mode") == "true";

const initialState = {
  darkModeEnabled:isEnabled
}

export default handleActions(
  {
    [GENERAL_ACTION.ENABLE_DARK_MODE]: (state, action) => ({
      ...state,
      darkModeEnabled: !state.darkModeEnabled
    })
  },
  initialState
)
